import { Modal, CircularProgress, Box } from "@mui/material";
import { useLoading } from "@/context/LoadingContext";

const LoadingOverlay = () => {
  const { isLoading } = useLoading();

  return (
    <Modal
      open={isLoading}
      sx={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      aria-busy={isLoading}
      aria-live="polite"
    >
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          outline: "none",
        }}
      >
        <CircularProgress
          size={60}
          thickness={4}
          color="primary"
        />
      </Box>
    </Modal>
  );
};

export default LoadingOverlay;
